export const plans = [
	{
		title: 'Anniversary Sale — 20% Off',
		desc: 'Celebrating 10 years of premium travel gear. Enjoy 20% off our entire collection for one week only — in-store and online.',
		author: 'Baginy Team',
		date: 'Apr 10 – Apr 17, 2026',
		location: 'Worldwide · Online & In-Store',
		img: '/img/anniversary2.jpeg',
	},
	{
		title: 'Limited Edition Drop',
		desc: 'Our most anticipated limited-run colourways are finally here. Each piece is numbered — once they are gone, they are gone.',
		author: 'Baginy Studio',
		date: 'Apr 20, 2026 · 10:00 AM',
		location: 'baginy.com · Exclusive Online',
		img: '/img/limited2.jpg',
	},
	{
		title: 'Pop-Up Event — Seoul',
		desc: 'Visit our flagship pop-up and experience the full Baginy lineup in person. Complimentary monogramming for all purchases.',
		author: 'Baginy Korea',
		date: 'May 3 – May 5, 2026',
		location: 'Seoul, Gangnam · Starfield COEX',
		img: '/img/new.jpeg',
	},
	{
		title: 'Flash Sale — 48 Hours Only',
		desc: 'Massive markdowns across selected luggage lines. Up to 40% off on carry-ons, check-in bags, and travel accessories.',
		author: 'Baginy Deals',
		date: 'May 12, 2026 · 00:00 – 48h',
		location: 'Online · All Regions',
		img: '/img/sale.avif',
	},
];
